import { usePathname } from 'next/navigation'
import React, { useState } from 'react'

import { useGetTradeInDDataQuery } from '@/screens/Product/api/productApiSlice'
import { useProduct } from '@/screens/Product/hooks/useProduct'
import tradeInIcon from '@/screens/Product/page/assets/trade-in.svg'

import { SvgArrowDown } from '@/shared/lib/@deprecated/iport-icons/iconsA/SvgArrowDown'
import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { Icon } from '@/shared/ui/icon'

import { TradeInForm } from './components/TradeInForm/TradeInForm'

import cl from './product-trade-in.module.scss'

export const ProductTradeIn = () => {
	const pathname = usePathname()
	const openModal = pathname.includes(`ref_open_modal`)

	const [isModalOpen, setIsModalOpen] = useState(openModal)
	const onOpen = () => setIsModalOpen(true)

	const { product } = useProduct()
	const { data: tradeInData } = useGetTradeInDDataQuery(Number(product.ID))

	if (!tradeInData) {
		return null
	}

	const tradeInMinPrice = product.PRICE.VALUE - tradeInData?.data?.PRICE

	return !!tradeInMinPrice ? (
		<>
			<button className={cl.root} onClick={onOpen}>
				<Icon icon={tradeInIcon} width={24} height={24} aria-label="icon" />
				<span>от {formatPrice(tradeInMinPrice)} в Трейд-ин </span>
				<SvgArrowDown size={20} className={cl.icon} />
			</button>

			<TradeInForm isOpened={isModalOpen} setIsModalOpen={setIsModalOpen} />
		</>
	) : (
		<></>
	)
}
